import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelector } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";


interface Params {
    image: Blob;
}
export interface Props extends kea.ModalProps<undefined, boolean, Params> { }


interface State {
    url: string;
}

/**
* Modal de edición para un 
*/
export class PopupModal extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            url:  window.URL.createObjectURL(props.params.image)
        }
    }

    componentWillUnmount = () => {
        window.URL.revokeObjectURL(this.state.url);
    }

    onCerrar = () => {
        this.props.onClose(false);
    }

    render() {
        return (
            <div style={{
                position: "fixed",
                background: "rgba(0,0,0,0.5)",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                width: "100%"
            }}
                onClick={this.onCerrar}
            >
                <div
                    className="modal"
                    role="dialog"
                    style={{ display: "block" }}
                    onClick={this.onCerrar}
                >
                    <div className="modal-dialog" onClick={this.onCerrar} style={{ textAlign: "center" }}  >
                        <img src={this.state.url} style={{ maxWidth: "28%" }} onClick={this.onCerrar} />
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/diseño/items/popupmodal.tsx